/*
 * Provide useful methods for manipulating alignment grids.
 */
var GridController = (function ($) {
	
	var win, timer;
	
	function ready() {
		win = $(window);
		win.on('load', equalizeGrids);
		win.on('resize', function () {
			clearTimeout(timer);
			timer = setTimeout(equalizeGrids, 44);
		});
	}
	
	// Given a selection of grids, equalize the heights on the children of the grid.
	function equalizeGrids() {
		$(".grid").each(function () {
			var grid = $(this);
			if (BreakpointController.isMobile()) {
				grid.children().css('height', '');
				return;
			}
			if (grid.hasClass('equalize') && grid.children().length > 1) {
				var shouldEqualize = grid.hasClass('equalize-content');
				var columnCount = parseInt(grid.attr('data-column-count'));
				var items = grid.children();
				
				// Split this array of items up in groups of <column count> and perform the equalization on there.
				if (columnCount && columnCount > 1) {
					for (var i=0; i<items.length; i+=columnCount) {
						equalizeHeights(items.slice(i, i + columnCount), shouldEqualize);
					}
				}
				else {
					equalizeHeights(items, shouldEqualize);	
				}
				
			}
		});
		equalizeTestimonialContentParagraphs();
	}

	function equalizeTestimonialContentParagraphs() {
	    $(".grid.list.testimonial-featured").each(function () {
	        var grid = $(this);
	        var h4s = grid.find('.callout h4'),
	            p1 = grid.find('.callout h4 + p'),
	            p2 = grid.find('.callout h4 + p + p');

	        equalizeHeights(h4s);
	        equalizeHeights(p1);
	        equalizeHeights(p2);
	    });
	}
	
	// Set the height of all the elements to the height of the tallest one.
	function equalizeHeights(selection, equalizeContent) {
		equalizeContent = !!equalizeContent;
		selection.show(); // Show all temporarily be able to calculate the height.
		
		// Remove inline height before proceeding.
		selection.add(selection.find('.equalize > *')).css('height', '');
		
		if (equalizeContent) {
			selection.find('.content').css('height', '');
		}
		var h = 0;
		selection.each(function () {
			var el = $(this);
			var elHeight = el.outerHeight();
			h = elHeight > h ? elHeight : h;
		});
		if (h > 0) {
			selection.css('height', h);
		}
		if (equalizeContent) {
			selection.each(function () {
				var el = $(this);
				var elHeight = el.outerHeight();
				var img = el.find('.img');
				var content = el.find('.content');
				if (img.length !== 0 && content.length !== 0) {
					content.css('height', elHeight - img.outerHeight());
				}
			});
		}
		// Remove forced display so elements can be hidden if the stylesheet specifies that behavior.
		selection.css('display', '');
	}
	
	$(ready);
	
	return {
		equalizeGrids: equalizeGrids,
		equalizeHeights: equalizeHeights
	};
	
})(jQuery);